import { Instagram, Phone } from 'lucide-react';

export default function FloatingSocial() {
  return (
    <div
      data-testid="floating-social"
      className="fixed left-3 top-1/2 -translate-y-1/2 z-50 flex flex-col gap-3"
    >
      <a
        href="https://www.instagram.com/ayzplastik?igsh=MWJ6c2djYTdoeTVhag%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-instagram"
        className="group w-12 h-12 rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-400 flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-200"
      >
        <Instagram size={20} />
      </a>
      <a
        href="https://wa.me/905542345454"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        className="group w-12 h-12 rounded-full bg-green-500 flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-200"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
